import { useMutation, type UseMutationResult } from '@tanstack/react-query';

import { createConversationMessage } from 'api/ai-assistant/ai-assistant-api';

interface UseApiCreateConversationMessageArgs {
  oktaUserId: string;
  clientId: string | number;
}

interface CreateMessageVariables {
  conversationId: string;
  data: unknown;
  onChunk?: (chunk: unknown) => void;
}

export const useApiCreateConversationMessage = ({
  oktaUserId,
  clientId,
}: UseApiCreateConversationMessageArgs): UseMutationResult<
  unknown,
  unknown,
  CreateMessageVariables
> =>
  useMutation<unknown, unknown, CreateMessageVariables>({
    mutationFn: ({ conversationId, data, onChunk }) =>
      createConversationMessage({
        oktaUserId,
        conversationId,
        data,
        onChunk,
        clientId,
      }),
  });
